import { ChevronDown } from '@carbon/icons-react';
import styled from 'styled-components';

export const CollapseIcon = styled(ChevronDown).attrs({ size: 16 })`
  transition: transform 0.3s;
  transform: rotate(-90deg);
  &.active {
    transform: rotate(0deg);
  }
`;
